// extracted by mini-css-extract-plugin
export default {"root":"AZSxe","xs":"nd9pF","sm":"oq86E","md":"tHz5c","lg":"JTbLL"};